import styled, { css } from 'styled-components';
import { Button as ButtonRac, Link as RacLink } from 'react-aria-components';

interface ButtonProps {
  $isFullWidth: boolean;
  $isSecondary: boolean;
}

const sharedStyles = css<ButtonProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-small);
  width: 100%;
  height: 44px;
  line-height: 44px;
  padding: var(--spacing-small) var(--spacing-base);
  background: ${props => (props.$isSecondary ? 'var(--white)' : 'var(--brand-500)')};
  border: 1px solid ${props => (props.$isSecondary ? 'var(--grey-300)' : 'var(--brand-500)')};
  border-radius: var(--radius-large);
  box-shadow: var(--shadow-xs);
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-semibold);
  color: ${props => (props.$isSecondary ? 'var(--grey-800)' : 'var(--black)')};
  line-height: 24px;

  &:is(.product__purchase-options &) {
    width: 100%;
    height: 48px;
    border-radius: var(--radius-base);
  }

  &:is(.product__purchase-options--notify &) {
    background: var(--purple-600);
    border-color: var(--purple-600);
    color: var(--white);

    &[data-hovered] {
      background: var(--purple-700);
      box-shadow: 0 0 0 4px var(--purple-100), 0 1px 2px 0 rgb(10 13 18 / 0.05);
    }

    & path {
      stroke: var(--white);
    }
  }

  &:is(.product__purchase-options--out-of-stock &) {
    background: var(--blue-light-300);
    border-color: var(--blue-light-300);

    &[data-hovered] {
      background: var(--blue-light-400);
      box-shadow: 0 0 0 4px var(--blue-light-100), 0 1px 2px 0 rgb(10 13 18 / 0.05);
    }
  }

  &:is(.product__purchase-options--pre-order &) {
    background: var(--pink-700);
    border-color: var(--pink-700);
    color: var(--white);

    &[data-hovered] {
      background: var(--pink-800);
      box-shadow: 0 0 0 4px var(--pink-100), 0 1px 2px 0 rgb(10 13 18 / 0.05);
    }

    & path {
      stroke: var(--white);
    }
  }

  &[data-hovered] {
    background: ${props => (props.$isSecondary ? 'var(--grey-50)' : 'var(--brand-600)')};
    box-shadow: var(--shadow-focus);
  }

  &[data-focus-visible] {
    box-shadow: var(--shadow-focus);
    border: 1px solid var(--brand-600);
    outline: 0;
  }

  @media (width >= 48rem) {
    width: ${props => (props.$isFullWidth ? '100%' : 'fit-content')};
  }
`;

export const Button = styled(ButtonRac)<ButtonProps>`
  ${sharedStyles}

  position: relative;
`;

export const Link = styled(RacLink)<ButtonProps>`
  ${sharedStyles}

  text-decoration: none;
`;

export const Icon = styled.span.attrs({ 'aria-hidden': true })`
  display: flex;
  width: 24px;
`;

export const ButtonText = styled.span<{ $isPending: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-small);
  width: fit-content;
  visibility: ${props => (props.$isPending ? 'hidden' : 'visible')};
`;
